import { Link } from 'react-router-dom';
import styles from './DashboardModules.module.css';

const ModuleEmptyState = ({
  icon,
  text,
  buttonText,
  onButtonClick,
  buttonLink,
}) => (
  <div className={styles.emptyState}>
    <i className={`fas ${icon} ${styles.emptyStateIcon}`}></i>
    <p>{text}</p>
    {buttonLink ? (
      <Link to={buttonLink} className="action-button secondary">
        {buttonText}
      </Link>
    ) : (
      <button onClick={onButtonClick} className="action-button secondary">
        {buttonText}
      </button>
    )}
  </div>
);

export default ModuleEmptyState;
